<template>
  <div class="gallery container">
    <section>
      <h1> Galleries </h1>
      <ul>
        <li v-for="(img, i) in filteredImages" :key="i" v-if="filteredImages">
          <router-link :to="{ path: `galleries/${i.toLowerCase()}`, query: { page: 1 } }">
          <progressive-background
            :src="img[0].thumbnail"
            :placeholder="placeholder"
            :aspect-ratio="isMobile ? 1 : 1.5">
            </progressive-background>
            <div class="content-container absolute-bottom">
              <div class="img-content absolute-bottom">
                <h1> {{ i }} </h1>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
    </section> 
  </div>
</template>

<script>
import placeholder from '../assets/placeholder.png';
import API from '../mixins/api';
import mobile from '../mixins/mobile';

export default {
  data() {
    return {
      placeholder,
    };
  },
  mixins: [API, mobile],
};
</script>

<style lang="scss" scoped>
  ul {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
  li {
    position: relative;
    width: 100%;
    margin-bottom: mm(2);
    @include respond-to(medium) {
      width: 30%;
      margin-right: 3.33%;
    }
  }
  .content-container {
    height: 100%;
    z-index: zindex(page);
  }
  .img-content {
    padding: spacing(element);
    z-index: zindex(page);
    color: color(white);
    background: rgba(0, 0, 0, 0.78);
    h1 {
      text-transform: capitalize;
      margin: 0;
    }
  }
</style>
